// Other libraries/dependencies
import { Fancybox } from '@fancyapps/ui/src/Fancybox/Fancybox.js';
window.Fancybox = Fancybox; // import 'slick-carousel';
// import 'alpinejs';